export default "__VITE_ASSET__DDIV5T7j__"